import { render, staticRenderFns } from "./pagelet-attr.vue?vue&type=template&id=479f05db&scoped=true"
import script from "./pagelet-attr.vue?vue&type=script&lang=js"
export * from "./pagelet-attr.vue?vue&type=script&lang=js"
import style0 from "./pagelet-attr.vue?vue&type=style&index=0&id=479f05db&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "479f05db",
  null
  
)

export default component.exports